import React, { useState, useEffect } from "react";
import { connectSearchDesktop } from "./SearchDesktop.connect";
import { useNavigate } from "react-router-dom";
import SVG_CricketIcon from "../../assets/images/svgs/cricket.svg?react";
import SVG_FootballIcon from "../../assets/images/svgs/football.svg?react";
import SVG_TennisIcon from "../../assets/images/svgs/tennis.svg?react";
import { useDispatch } from "react-redux";
import {
  setHrEventId,
  setHrMarketId,
  setIsAnimatedText,
  setIsDetailedGroupName,
  setIsEventDetailed,
  setIsNavigationID,
  setIsNavigationName,
} from "../../store/navigationHeaderMenu/navigationHeaderMenu.slice";
import { requestSportPageEvent } from "../../store/sportPageEvent/sportPageEvent.thunks";
import { requestCompetition } from "../../store/competitions/competitions.thunks";
import { requestHomeAllCompetition } from "../../store/homeMarketEvents/homeMarketEvents.thunks";

const SearchDesktop = ({
  search,
  menu,
  auth,
  actions,
  animatedText,
  searchValue,
  elementsParams,
  freeHomeAllMarkets,
  closeOnMobile,
  searchList,
  // searchValues,
}) => {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [result, setResult] = useState([]);

  useEffect(() => {
    actions.requestSearchList();
  }, []);

  useEffect(() => {
    setMenus(searchList);
  }, [searchList]);

  // useEffect(() => {
  //   if (menu && (!menus || menus.length === 0)) {
  //     setMenus(menu);
  //   }
  // }, [menu]);

  const dispatch = useDispatch();

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    if (width !== elementsParams?.clientWidth)
      actions.setClientWidthThunk(width);

    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      actions.setClientWidthThunk(newWidth);
    };
    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  const gotoEvent = (item) => {
    if (!auth) {
      actions.setLoginNew(true);
      actions.setLoginNavigationData(
        item.sport_id == "77777"
          ? { page: "casino_live", ids: [item.id] }
          : { page: "event-page", ids: [item.sport_id, item.match_id] }
      );
    } else if (item.sport_id == "77777") {
      navigate(`/casino_live/${item.id}`);
    } else {
      dispatch(setIsDetailedGroupName(item?.series_name));
      dispatch(setIsEventDetailed(false));
      const data = {
        sport_id: item?.sport_id,
      };

      dispatch(requestHomeAllCompetition(data));

      if (item?.sport_id === "7" || item?.sport_id === "4339") {
        dispatch(setIsNavigationID(item?.sport_id));
        dispatch(
          setIsNavigationName(
            item?.sport_id === "7" ? "Horse Racing" : "Greyhound Racing"
          )
        );
        dispatch(setHrEventId(item.match_id));
        dispatch(setHrMarketId(item?.market_id));

        navigate(
          item?.sport_id === "7" ? "/horse-racing" : "/greyhound-racing"
        );
        return;
      }
      navigate(`/event-page/${item.sport_id}/${item.match_id}/${item?.match_name}`);
    }
    dispatch(setIsAnimatedText(false));
  };

  // useEffect(() => {
  //   const result = [];

  //   if (freeHomeAllMarkets && freeHomeAllMarkets?.length) {
  //     freeHomeAllMarkets.forEach((innerArray) => {
  //       innerArray.forEach((obj) => {
  //         obj.data.filter(
  //           (event) =>
  //             event.eventName
  //               .toLowerCase()
  //               .indexOf(search.value.toLowerCase()) !== -1 &&
  //             result.push({ ...event })
  //         );
  //       });
  //     });
  //   }

  //   setResult(result);
  // }, [menus, search]);

  useEffect(() => {
    const result = [];
    if (menus)
      menus.filter(
        (event) =>
          event?.match_name
            ?.toLowerCase()
            .indexOf(search?.value.toLowerCase()) !== -1 &&
          result.push({ ...event, eventTypeId: event.sport_id })
      );
    setResult(result);
  }, [menus, search]);

  if (width < 1024) {
    return (
      <>
        {search.value && (
          <div
            className="lg:hidden absolute top-8 right-10 w-full peer gap-4 appearance-none text-xs p-3 border flex flex-col bg-bg_Quaternary rounded-md shadow-[0_3px_10px_rgb(0,0,0,0.2)] text-text_Ternary  overflow-y-auto max-h-[300px]"
            style={{ zIndex: 1000 }}
          >
            {search.value.length > 2 && result && result.length ? (
              result.map((eventElement, id) => (
                <div
                  className="cursor-pointer  border-b border-quinary  pb-1 border-quinary  text-medium w-full flex font-lato font-bold"
                  onClick={() => {
                    gotoEvent(eventElement);
                    actions.setSearchValues("");
                    actions.setIsAnimatedText(false);
                    closeOnMobile();
                  }}
                >
                  <span className="w-full flex flex-row">
                    <span className="flex items-center justify-center">
                      {eventElement.sport_id == 4 ||
                      eventElement.sport_id == "b9" ||
                      eventElement.sport_id == "v9" ? (
                        <SVG_CricketIcon />
                      ) : eventElement.sport_id == 1 ? (
                        <SVG_FootballIcon />
                      ) : eventElement.sport_id == 2 ? (
                        <SVG_TennisIcon />
                      ) : null}
                    </span>
                    <span className="ml-1 font-lato-bold text-base break-words">
                      {eventElement.match_name}
                    </span>
                  </span>
                </div>
              ))
            ) : (
              <div className="flex font-lato items-center justify-center w-full">
                No data found
              </div>
            )}
          </div>
        )}
      </>
    );
  }

  const renderResults = () => {
    if (search.value.length > 2) {
      return result && result.length ? (
        result.map((eventElement, id) => (
          <div
            key={"resultRender" + id}
            className="  border-b border-quinary cursor-pointer px-2 py-1 text-medium w-full flex font-lato font-bold"
            onClick={() => {
              gotoEvent(eventElement);
              actions.setSearchValues("");
              actions.setIsAnimatedText(false);
              closeOnMobile();
            }}
          >
            <span className="text-nowrap w-full whitespace-nowrap flex flex-row">
              <span className="flex items-center justify-center">
                {eventElement.sport_id == 4 ||
                eventElement.sport_id == "b9" ||
                eventElement.sport_id == "v9" ? (
                  <SVG_CricketIcon />
                ) : eventElement.sport_id == 1 ? (
                  <SVG_FootballIcon />
                ) : eventElement.sport_id == 2 ? (
                  <SVG_TennisIcon />
                ) : null}
              </span>
              <span className="ml-1 font-lato-bold text-base">
                {eventElement.match_name}
              </span>
            </span>
          </div>
        ))
      ) : (
        <>
          <div className="flex font-lato items-center py-4 md:py-2 justify-center w-full">
            No data found
          </div>
        </>
      );
    } else
      return (
        <div className="flex font-lato items-center py-4 md:py-2 justify-center w-full">
          No data found
        </div>
      );
  };

  return (
    <div className="hidden lg:block absolute top-10 left-4 right-2 w-full rounded-md shadow-[0_3px_10px_rgb(0,0,0,0.2)] text-xs bg-bg_Quaternary text-text_Ternary  overflow-y-auto max-h-[200px]">
      {renderResults()}
    </div>
  );
};

export default connectSearchDesktop()(SearchDesktop);
